import React, { useEffect } from 'react';
import '../styles/Company.css';
import { updatePageSEO, seoData } from '../utils/SeoUtils';

function Company() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);

    // Update SEO for company page
    updatePageSEO(seoData.company.title, seoData.company.description, seoData.company.keywords);
  }, []);

  return (
    <div className="company">
      <section className="company-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Nossa História</h2>
              <p>
                A MEGATON foi fundada com uma missão simples: fornecer serviços confiáveis, seguros
                e profissionais de munck e guindaste para empresas e pessoas físicas em Rondonópolis
                e regiões vizinhas.
              </p>
              <p>
                Com anos de experiência na indústria de içamento pesado, construímos uma reputação
                de excelência, segurança e satisfação do cliente. Nossa equipe de operadores
                certificados e frota moderna de equipamentos garante que cada trabalho seja
                concluído com os mais altos padrões.
              </p>
            </div>
            <div className="story-image">
              <img
                src="/images/portifolio/img5.jpeg"
                alt="Equipamentos da empresa"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="company-values">
        <div className="container">
          <h2>Nossos Valores</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>🛡️ Segurança em Primeiro Lugar</h3>
              <p>
                A segurança é nossa prioridade máxima. Todos os nossos operadores são certificados e
                seguem protocolos rigorosos de segurança para garantir que cada operação seja
                conduzida com segurança.
              </p>
            </div>
            <div className="value-card">
              <h3>⚡ Confiabilidade</h3>
              <p>
                Entendemos a importância dos prazos. Nossa equipe está comprometida a entregar no
                prazo, sempre, com qualidade consistente de serviço.
              </p>
            </div>
            <div className="value-card">
              <h3>🤝 Foco no Cliente</h3>
              <p>
                Sua satisfação é o nosso sucesso. Trabalhamos de perto com cada cliente para
                entender suas necessidades e fornecer soluções personalizadas.
              </p>
            </div>
            <div className="value-card">
              <h3>📈 Excelência em Qualidade</h3>
              <p>
                Mantemos os mais altos padrões na manutenção de equipamentos, treinamento de
                operadores e entrega de serviços.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/*
      <section className="company-stats">
        <div className="container">
          <h2>Nossos Números</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <h3>500+</h3>
              <p>Projetos Concluídos</p>
            </div>
            <div className="stat-item">
              <h3>24/7</h3>
              <p>Atendimento Emergencial</p>
            </div>
            <div className="stat-item">
              <h3>10+</h3>
              <p>Anos de Experiência</p>
            </div>
            <div className="stat-item">
              <h3>100%</h3>
              <p>Histórico de Segurança</p>
            </div>
          </div>
        </div>
      </section>
      */}

      <section className="team-section">
        <div className="container">
          <h2>Nossa Equipe</h2>
          <p>
            Nossa equipe é composta por profissionais experientes que são apaixonados por fornecer
            serviços excepcionais. Todos os nossos operadores são certificados e passam por
            treinamento regular para se manterem atualizados com as melhores práticas da indústria e
            padrões de segurança.
          </p>
          <div className="team-features">
            <div className="team-feature">
              <h4>Operadores Certificados</h4>
              <p>Todos os membros da equipe possuem certificações e licenças atualizadas</p>
            </div>
            <div className="team-feature">
              <h4>Treinamento Contínuo</h4>
              <p>Programas regulares de treinamento para garantir desempenho superior</p>
            </div>
            <div className="team-feature">
              <h4>Experiência</h4>
              <p>Anos de experiência prática em operações complexas</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Company;
